module.exports = __webpack_public_path__ + "media/brands/jaguar-13f93119.png";